// extracted by mini-css-extract-plugin
module.exports = {"creationSectionHeader":"CreationSection_creationSectionHeader__ga4Bg","creationList":"CreationSection_creationList__LwEVm"};